module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_straight.86fe06f5.png";